import React from 'react';

export default function FunFact({ data, colorVariant }) {
  return (
    <div className="cs_counter_1_wrap">
      {data.map((item, index) => (
        <div
          className={`cs_counter cs_style_1 position-relative d-flex align-items-center ${
            colorVariant ? colorVariant : ''
          }`}
          key={index}
        >
          <div
            className={`cs_counter_nmber mb-0 cs_fs_68 d-flex align-items-center cs_bold cs_primary_color`}
          >
            {item.number}
          </div>
          <p className="cs_counter_title mb-0">{item.title}</p>
        </div>
      ))}
    </div>
  );
}




// import React from 'react';

// export default function FunFact({ data, colorVariant }) {
//   return (
//     <>
//       <div className="cs_counter_1_wrap">
//         <div className="funfact-row">
//           {data.map((item, index) => (
//             <div
//               className={`cs_counter cs_style_1 d-flex align-items-center ${
//                 colorVariant ? colorVariant : ''
//               }`}
//               key={index}
//             >
//               <div className="cs_counter_number cs_fs_68 cs_bold cs_primary_color me-2">
//                 {item.number}
//               </div>
//               <p className="cs_counter_title mb-0">{item.title}</p>
//             </div>
//           ))}
//         </div>
//       </div>

//       <style>{`
//         .funfact-row {
//           display: flex;
//           gap: 2rem;
//           flex-wrap: wrap;
//         }

//         @media (max-width: 767px) {
//           .funfact-row {
//             flex-wrap: nowrap;
//             overflow-x: auto;
//             -webkit-overflow-scrolling: touch;
//             scrollbar-width: none;
//           }

//           .funfact-row::-webkit-scrollbar {
//             display: none;
//           }

//           .cs_counter {
//             flex: 0 0 auto;
//             min-width: max-content;
//           }

//           .cs_counter_number {
//             font-size: 2rem;
//             white-space: nowrap;
//           }

//           .cs_counter_title {
//             white-space: nowrap;
//           }
//         }
//       `}</style>
//     </>
//   );
// }
